module.exports = __webpack_public_path__ + "img/list2.a21b2fd0.png";